import { render, staticRenderFns } from "./CapitalizeFirst.vue?vue&type=template&id=6725c957&scoped=true"
import script from "./CapitalizeFirst.vue?vue&type=script&lang=js"
export * from "./CapitalizeFirst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6725c957",
  null
  
)

export default component.exports